import apiClient from './client';

/** B5+B6 技能引用归因 / 离线沉淀（SkillClaw / SkillOpt-Sleep 借鉴）API 客户端。 */

export type PrecipitationStatus = 'pending' | 'verified' | 'adopted' | 'rejected';
export type PrecipitationKind = 'new_skill' | 'skill_improvement';

export interface PrecipitationProposal {
  id: string;
  agent_id: string;
  status: PrecipitationStatus;
  kind: PrecipitationKind;
  payload: Record<string, unknown>;
  evidence: Record<string, unknown>;
  score_before: number | null;
  score_after: number | null;
  verification_note: string | null;
  adopted_skill_id: string | null;
  /** B23 模型切换告警：提案创建时生效 LLM 配置指纹（provider/model），取不到为 null */
  llm_fingerprint: string | null;
  /** B23 模型切换告警：记录指纹 vs 当前生效模型比较（drifted=true 时前端展示黄色告警条） */
  model_drift: { drifted: boolean; message: string | null };
  /** B17：已采纳新技能的信任档位（quarantined/active/global；未采纳为 null） */
  adopted_skill_trust_state?: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface SkillMiningRunPayload {
  window_days?: number;
  /** 是否做留出集验证（需要 suite_id / suite_path；无 LLM 时候选保持 pending 并说明） */
  verify?: boolean;
  suite_id?: string;
  suite_path?: string;
}

export async function runSkillMining(
  agentId: string,
  payload: SkillMiningRunPayload = {},
): Promise<{ agent_id: string; job_id: string }> {
  const res = await apiClient.post(`/agents/${agentId}/skill-mining/run`, payload);
  return res.data;
}

export async function listSkillMiningProposals(
  agentId: string,
  status?: PrecipitationStatus,
): Promise<PrecipitationProposal[]> {
  const res = await apiClient.get(`/agents/${agentId}/skill-mining/proposals`, {
    params: status ? { status } : undefined,
  });
  return res.data;
}

export async function adoptSkillMiningProposal(
  proposalId: string,
): Promise<{ proposal: PrecipitationProposal; applied: Record<string, unknown> }> {
  const res = await apiClient.post(`/skill-mining/proposals/${proposalId}/adopt`);
  return res.data;
}

export async function rejectSkillMiningProposal(
  proposalId: string,
  reason?: string,
): Promise<{ proposal: PrecipitationProposal }> {
  const res = await apiClient.post(`/skill-mining/proposals/${proposalId}/reject`, { reason });
  return res.data;
}
